import { PropsWithChildren } from 'react';
import { Splitter } from 'antd';
import styles from './ResizableSidebarPageLayout.module.scss';

type ResizableSidebarPageLayoutProps = {
  sidebar: React.ReactNode;
};

const ResizableSidebarPageLayout: React.FC<PropsWithChildren<ResizableSidebarPageLayoutProps>> = ({
  sidebar,
  children,
}): React.ReactElement => {
  return (
    <Splitter className={styles.calendarLayout}>
      <Splitter.Panel defaultSize={250} min={200} max={320} className={styles.sidebar}>
        {sidebar}
      </Splitter.Panel>
      <Splitter.Panel className={styles.content}>{children}</Splitter.Panel>
    </Splitter>
  );
};

export { ResizableSidebarPageLayout };
